import { createComponent as o, createElement as a, createHook as r } from "../../../ariakit-react-utils/esm/system.js";
import { useVisuallyHidden as n } from "../visually-hidden/visually-hidden.js";
const s = r((e) => (e = {
  "data-focus-trap": "",
  tabIndex: 0,
  "aria-hidden": !0,
  ...e,
  style: {
    // Prevents unintended scroll jumps.
    position: "fixed",
    top: 0,
    left: 0,
    ...e.style
  }
}, e = n(e), e)), c = o((e) => {
  const t = s(e);
  return a("span", t);
});
process.env.NODE_ENV !== "production" && (c.displayName = "FocusTrap");
export {
  c as FocusTrap,
  s as useFocusTrap
};
//# sourceMappingURL=focus-trap.js.map
